import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function PaymentResult({ success }) {
  const { refreshUser } = useAuth();
  const [state, setState] = useState(success ? "checking" : "cancel");
  const tries = useRef(0);
  useEffect(() => {
    if (!success) {
      return;
    }
    const sid = new URLSearchParams(window.location.search).get("session_id");
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          setState("paid");
          refreshUser();
          return;
        }
        if (["expired", "failed"].includes(data.payment_status)) {
          setState("failed");
          return;
        }
      } catch (e) {
        setState("failed");
        return;
      }
      tries.current += 1;
      if (tries.current < 15) timer = setTimeout(poll, 2000);
      else setState("pending");
    };
    poll();
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  const view = {
    checking: [Loader2, "Verifica pagamento in corso…", "text-slate-300 animate-spin"],
    paid: [CheckCircle2, "Pagamento completato! Crediti/abbonamento attivati.", "text-green-400"],
    pending: [Loader2, "Pagamento in elaborazione. Ricontrolla tra qualche minuto.", "text-amber-300"],
    failed: [XCircle, "Pagamento non riuscito o scaduto.", "text-red-400"],
    cancel: [XCircle, "Pagamento annullato. Nessun addebito effettuato.", "text-slate-400"],
  }[state];
  const [Icon, msg, cls] = view;
  return (
    <div className="min-h-screen grid place-items-center p-4 grid-bg">
    <div className="surface w-full max-w-lg p-10 text-center" data-testid="payment-result">
      <Icon className={`mx-auto mb-4 ${cls}`} size={48} />
      <p className="text-lg text-white" data-testid="payment-result-message">{msg}</p>
      {window.opener && <p className="text-sm text-slate-400 mt-3">Puoi chiudere questa scheda e tornare all'app.</p>}
      <div className="flex gap-3 justify-center mt-8">
        <Link to="/dashboard" className="btn-ghost px-5 py-2.5 text-sm" data-testid="payment-go-dashboard">Le tue richieste</Link>
        {state === "paid" && <Link to="/nuova-richiesta" className="btn-red px-5 py-2.5 text-sm" data-testid="payment-new-ticket">Apri un ticket</Link>}
      </div>
    </div>
    </div>
  );
}
